import { useEffect, useState } from 'react';

export const homepageBranchLink = 'https://alltrails.io/rgGVELw1wCb';

const useDeeplink = (pageType?: 'area' | 'trail', pageId?: number) => {
  // Use app homepage deeplink for initial state.
  const [deeplink, setDeeplink] = useState(homepageBranchLink);

  useEffect(() => {
    const branchLinkBase = 'https://alltrails-alternate.app.link';

    let appPath = `alltrails://screen/explore`;

    if (pageType && pageId) {
      appPath = `alltrails://${pageType}/${pageId}`;
    }

    const branchDeeplink = `${branchLinkBase}?type=install_prompt&$ios_deeplink_path=${appPath}&$android_deeplink_path=${appPath}`;

    setDeeplink(branchDeeplink);
  }, [pageId, pageType]);

  return deeplink;
};

export default useDeeplink;
